import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
// Hooks
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import BasicTimeoffPolicyForm from 'modules/timeoff/lib/TimeoffPolicy/Basic'
import timeoffPolicies from 'modules/timeoff/store/collections/timeoffPolicies/policies'

interface Props {
  onClose: () => void
  onSuccess: (id: number) => void
}

const AddPolicyModal = ({ onClose, onSuccess }: Props) => {
  const form = React.useMemo(
    () =>
      new BasicTimeoffPolicyForm({
        days_type: 'working_days',
      }),
    []
  )

  const isFormFilled = !!form.get('name').value

  const { running, performAction: onSubmit } = useAsyncAction(async () => {
    const { id } = await form.create(timeoffPolicies)
    onSuccess(id)
  })
  return (
    <Modal
      illustration="holidays-event-go"
      title={i18n.t('settings.timeoff_policies.add_modal.title')}
      description={i18n.t('settings.timeoff_policies.add_modal.description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button disabled={running || !isFormFilled} submit>
          {i18n.t('settings.timeoff_policies.add_modal.button')}
        </Button>
      }
    >
      <Text label={i18n.t('settings.timeoff_policies.fields.name')} field={form.get('name')} />
    </Modal>
  )
}

export default observer(AddPolicyModal)
